// import React from "react";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// ChartJS.register(ArcElement, Tooltip, Legend);

// const EnrolledPaperCompletionGraph = () => {
//   const data = {
//     labels: ["Completed", "Remaining"],
//     datasets: [
//       {
//         data: [72, 28],
//         backgroundColor: ["#63239A", "#FCEFD4"],
//         borderWidth: 0,
//         borderRadius: 10,
//         cutout: "70%", // Makes it look like a donut
//       },
//     ],
//   };

//   const options = {
//     rotation: 0,
//     circumference: 360,
//     plugins: {
//       legend: {
//         display: false,
//       },
//     },
//   };

//   return (
//     <div className="card-box">
//       <h6>Enrolled paper completing level</h6>
//       <div style={{ position: "relative", width: "12rem", margin: "auto" }}>
//         <Doughnut data={data} options={options} />
//         <div
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             fontWeight: "bold",
//             fontSize: "20px",
//             color: "#63239A",
//           }}
//         >
//           72%
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EnrolledPaperCompletionGraph;


import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import "./TheStudentDashboard.css";
import Medal from './imageFiles/Medal.png';
import { Skeleton } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend);

const EnrolledPaperCompletionGraph = ({ completionPercentage, student_dashboard_initial_loading }) => {

  const data = {
    labels: ["Completed", "Remaining"],
    datasets: [
      {
        data: [completionPercentage, 100 - completionPercentage],
        backgroundColor: ["#63239A", "#FCEFD4"],
        borderWidth: 0,
        borderWidth: 0,
        borderRadius: 10,
        cutout: "75%",
      },
    ],
  };

  const options = {
    rotation: 0,
    circumference: 360,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className="enrolled-progress-box">
      <h6 className="section-title-student">Enrolled exam completing level</h6>
      {student_dashboard_initial_loading ?
        <div style={{ display: 'flex', justifyContent: "space-between" }}>
          <Skeleton
            sx={{
              height: '120px',
              width: '140px',
              borderRadius: "10px"
            }}
            variant="rectangular"
            animation="wave"
          />
          <Skeleton
            sx={{
              height: '120px',
              width: '120px',
            }}
            variant="circular"
            animation="wave"
          />
        </div>
        :
        <div className="enrolled-progress-content row">
          <div className=" ">
            <div className="doughnut-wrapper progress-donut">
              <Doughnut data={data} options={options} />
              <div className="doughnut-center-text">{completionPercentage}%</div>
            </div>
          </div>
          <div className="">
            <div className="d-flex justify-content-center align-items-center">
              <img
                src={Medal}
                className="medal-img"
                alt="Medal"
              />
            </div>
          </div>
        </div>

      }
    </div>
  );
};

export default EnrolledPaperCompletionGraph;
